import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightningFilledIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.0772 1.68153C11.1208 1.3328 10.9293 0.997082 10.6069 0.85714C10.2845 0.717198 9.90845 0.806539 9.68346 1.07652L2.6143 9.55951C2.49214 9.70606 2.3684 9.85449 2.27831 9.98492C2.1931 10.1083 2.03753 10.3508 2.03273 10.6696C2.02723 11.0345 2.18984 11.3817 2.47371 11.6111C2.72168 11.8115 3.0076 11.8473 3.15691 11.8608C3.31479 11.8751 3.50803 11.875 3.69881 11.875L8.60319 11.875L7.92275 17.3185C7.87916 17.6672 8.07069 18.0029 8.39307 18.1429C8.71545 18.2828 9.09149 18.1935 9.31648 17.9235L16.3856 9.4405C16.5078 9.29396 16.6315 9.14552 16.7216 9.01508C16.8068 8.89172 16.9624 8.64918 16.9672 8.33041C16.9727 7.96547 16.8101 7.61828 16.5262 7.38888C16.2783 7.18851 15.9923 7.15274 15.843 7.13922C15.6851 7.12493 15.4919 7.12497 15.3011 7.125L10.3968 7.125L11.0772 1.68153Z",
		fill: "currentColor"
	})
});
export default SvgLightningFilledIcon;
